import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css'; // Importa os estilos globais da aplicação.
import App from './App'; // O componente principal que contém as rotas e a estrutura da página.
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './contexts/AuthContext'; // Importa o nosso provedor de contexto.

// --- PONTO DE ENTRADA DA APLICAÇÃO ---

// 1. Seleciona o elemento HTML com o id 'root' (geralmente uma div no public/index.html).
// Este é o "contentor" onde toda a nossa aplicação React será renderizada.
const rootElement = document.getElementById('root') as HTMLElement;

// 2. Cria a "raiz" da aplicação React usando a API moderna do React 18.
const root = ReactDOM.createRoot(rootElement);

// 3. Renderiza a aplicação na raiz.
root.render(
  // <React.StrictMode> é uma ferramenta para destacar potenciais problemas na aplicação.
  // Ajuda a identificar código inseguro, obsoleto ou com efeitos secundários inesperados.
  // Ele não afeta a build de produção.
  <React.StrictMode>
    
    {/*
      O <AuthProvider> é o nosso Provedor de Contexto. Ao "envolver" o componente <App />,
      estamos a garantir que qualquer componente dentro de <App> (ou seja, qualquer
      componente na nossa aplicação) possa aceder ao contexto de autenticação.

      Isto significa que qualquer página ou componente poderá saber se o utilizador está
      logado, obter os dados do utilizador e usar as funções de login/logout,
      simplesmente usando o hook `useAuth()`.
    */}
    <AuthProvider>
      <App />
    </AuthProvider>
    
  </React.StrictMode>
);

// A função reportWebVitals é usada para medir a performance da sua aplicação.
// Pode enviar métricas como tempo de carregamento, interatividade, etc., para um endpoint de análise.
// É opcional, mas útil para monitorizar a saúde da aplicação em produção.
reportWebVitals();
